'use client';
/* Built In Imports */
import { useRef, useState } from 'react';

/* External Imports */
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Box, Center, Flex, Image } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import { useMediaQuery } from 'react-responsive';
import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

/* Internal Imports */
/* Components */

/* Services */
/* Styles */
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Slider = ({ sectionContent }) => {
  const [my_swiper, set_my_swiper] = useState({});
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const pagination = {
    clickable: true,
    spaceBetween: 40,
    el: '.custom-pagination',
    height: '40px',
    bulletActiveClass: 'active-bullet bullet',
  };
  const isMobile = useMediaQuery({ maxWidth: 767 });
  if (sectionContent?.images.length === 2 && !isMobile) {
    return (
      <Flex
        width="100%"
        maxW="670px"
        mx="auto"
        gridGap="15px"
        mt="20px"
        mb="30px"
      >
        {sectionContent.images.map(image => {
          return (
            <Box flex={1} borderRadius="8px" h="310px" key={nanoid()}>
              <Image
                borderRadius="8px"
                objectFit="cover"
                h="100%"
                width="100%"
                src={image?.url}
                alt={image?.alt || image?.title || ''}
              />
            </Box>
          );
        })}
      </Flex>
    );
  }
  if (sectionContent?.images?.length > 2) {
    return (
      <Box
        maxW="720px"
        overflow="visible"
        w="100%"
        mx="auto"
        minH={{ base: 'auto', sm: '250px', md: '450px' }}
        px={{ base: '0px', md: '0' }}
        my="20px"
      >
        <Swiper
          style={{ padding: '0 25px' }}
          onSwiper={swiper => {
            // Delay execution for the refs to be defined
            setTimeout(() => {
              // Override prevEl & nextEl now that refs are defined
              swiper.params.navigation.prevEl = navigationPrevRef.current;
              swiper.params.navigation.nextEl = navigationNextRef.current;

              // Re-init navigation
              swiper.navigation.destroy();
              swiper.navigation.init();
              swiper.navigation.update();
            });
          }}
          modules={[Navigation, Pagination, EffectFade]}
          loop={true}
          slidesPerView={1}
          onInit={ev => {
            set_my_swiper(ev);
          }}
          // navigation={true}
          navigation={{
            // Both prevEl & nextEl are null at render so this does not work
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          pagination={pagination}
          spaceBetween={50}
          // onSwiper={(swiper) => console.log(swiper)}
          initialSlide={0}
          // slidesPerView={1}
          // onSlideChange={(e) => { setSIndex(e.activeIndex); }}
          // style={{ padding: isMobile ? '0 15px' : '0 23px' }}
        >
          {sectionContent?.images?.map(image => {
            return (
              <SwiperSlide
                key={nanoid()}
                onTouchStart={() => my_swiper.slideNext()}
                onClick={() => my_swiper.slideNext()}
                maxWidth="670px"
                width="100%"
                ml={{ base: '0px', md: '4px' }}
              >
                <Box w="100%" pos="relative" borderRadius="12px">
                  <Box
                    pos="absolute"
                    top="0"
                    left="0"
                    height="100%"
                    width="20%"
                    borderRadius="12px 0 0 12px"
                    bg="linear-gradient(90deg, rgba(37, 22, 22, 0.47) 0%, rgba(43, 25, 25, 0.00) 100%)"
                    opacity="0.4"
                  ></Box>
                  <Box
                    pos="absolute"
                    top="0"
                    right="0"
                    height="100%"
                    width="20%"
                    borderRadius="0 12px 12px 0"
                    bg="linear-gradient(270deg, rgba(37, 22, 22, 0.47) 0%, rgba(43, 25, 25, 0.00) 100%)"
                    opacity="0.4"
                  ></Box>

                  <Image
                    src={image.url}
                    alt={image?.alt || image?.title || ''}
                    // mt="42%"
                    w="100%"
                    rounded="md"
                    height="100%"
                    bgSize="cover"
                    bgPos="center"
                    borderRadius="12px"
                  />
                </Box>
              </SwiperSlide>
            );
          })}
          <Box
            className="custom-pagination"
            w="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
            h={{ base: '25px', md: '50px' }}
          ></Box>
          <Center
            filter="drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.10)) drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.09)) drop-shadow(0px 7px 4px rgba(0, 0, 0, 0.05)) drop-shadow(0px 13px 5px rgba(0, 0, 0, 0.01)) drop-shadow(0px 20px 6px rgba(0, 0, 0, 0.00))"
            fontSize={{ base: '22px', md: '30px' }}
            top={{ base: 'calc(50% - 25.5px)', md: 'calc(50% - 36.5px)' }}
            ref={navigationPrevRef}
            borderRadius="50%"
            background={`#FBAD18`}
            _hover={{
              bg: '#DB9000',
              color: '#fff',
            }}
            color="#622210"
            pos="absolute"
            bgSize="cover"
            bgRepeat="no-repeat"
            w={{ base: 31, md: 53 }}
            h={{ base: 31, md: 53 }}
            zIndex={1000}
            left={{ base: '0', md: '0' }}
            cursor="pointer"
          >
            <ChevronLeftIcon />
          </Center>
          <Center
            filter="drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.10)) drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.09)) drop-shadow(0px 7px 4px rgba(0, 0, 0, 0.05)) drop-shadow(0px 13px 5px rgba(0, 0, 0, 0.01)) drop-shadow(0px 20px 6px rgba(0, 0, 0, 0.00))"
            color="#622210"
            fontSize={{ base: '22px', md: '30px' }}
            top={{ base: 'calc(50% - 25.5px)', md: 'calc(50% - 36.5px)' }}
            borderRadius={'50%'}
            right={{ base: '0', md: '0' }}
            background={`#FBAD18`}
            ref={navigationNextRef}
            cursor="pointer"
            pos="absolute"
            bgSize="cover"
            bgRepeat="no-repeat"
            w={{ base: 31, md: 53 }}
            h={{ base: 31, md: 53 }}
            zIndex={1000}
            _hover={{
              bg: '#DB9000',
              color: '#fff',
            }}
          >
            <ChevronRightIcon />
          </Center>
        </Swiper>
        <style global jsx>
          {`
            .swiper-slide {
              -webkit-backface-visibility: hidden;
              -webkit-transform: translate3d (0, 0, 0);
            }

            .custom-pagination span {
              width: 8px !important;
              display: inline-block;
              height: 8px !important;
              border-radius: 50%;
              background: #fbad18;
              opacity: 0.3;
              margin: 0 5px;
              cursor: pointer;
            }
            .custom-pagination .active-bullet {
              opacity: 1;
              width: 8px !important;
              display: inline-block;
              height: 8px !important;
              border-radius: 50%;
              background: #fbad18;
              cursor: pointer;
            }
          `}
        </style>
      </Box>
    );
  }
};
export default Slider;
